<template>
    <rkm-layout-body title="Lista de kit de exames">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'parametrizacao-kit-exame-create' })"
                color="primary"
                authorize="store-parametrizacao-kit-exame"
            >
                Cadastrar kit de exame
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/parametrizacao/kit-exame/List'

export default {
    components: { List },
}
</script>